module.exports = __webpack_public_path__ + "img/one.1921c6e1.png";